import { APIBase } from '../api-base'

export class IdentityFormAPI extends APIBase {
    /**
     * Send email containing passwordless login
     *
     * @param data
     */
    public static async sendPasswordlessEmail(data: Record<string, string>) {
        const csrfTokenInputElement = document.querySelector('[name=csrfmiddlewaretoken]') as HTMLInputElement
        const csrfToken = (csrfTokenInputElement) ? csrfTokenInputElement.value : ''
        const url = `/api-root/subscription/identity/request_passwordless_link/`

        return IdentityFormAPI.postData(url, data, csrfToken)
    }

    /**
     * Call Send Verification Email API endpoint.
     *
     * @param data any - data to be submitted
     */
    public static async sendVerificationEmail(data: Record<string, unknown> & {csrfmiddlewaretoken: string}) {
        const url = `/api-root/subscription/identity/send_verification_email/`
        const {csrfmiddlewaretoken, ...formData} = data

        return IdentityFormAPI.postData(url, formData, csrfmiddlewaretoken)
    }

    /**
     * Call Request Reset Password Email API endpoint.
     *
     * @param data any - data to be submitted
     */
    public static async sendResetPasswordEmail(data: Record<string, unknown> & {csrfmiddlewaretoken: string}) {
        const url = `/api-root/subscription/identity/request_reset_password_email/`
        const {csrfmiddlewaretoken, ...formData} = data

        return IdentityFormAPI.postData(url, formData, csrfmiddlewaretoken)
    }

    /**
     * Reset Password
     *
     * @param data
     */
    public static async resetPassword(data: Record<string, unknown> & {csrfmiddlewaretoken: string}) {
        const url = `/api-root/subscription/identity/reset_password/`
        const {csrfmiddlewaretoken, ...formData} = data

        return IdentityFormAPI.postData(url, formData, csrfmiddlewaretoken)
    }
}
